export default "__VITE_ASSET__BiL14UVq__"